import { useState, useLayoutEffect, useEffect } from 'react';

const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;

const getScrollInfo = () => {
  const { top, right, bottom, left, x, y } =
    typeof window !== 'undefined'
      ? window.document.body.getBoundingClientRect()
      : {};
  return { top, right, bottom, left, x, y };
};

export default function useScrollInfo() {
  const [scrollInfo, setScrollInfo] = useState(getScrollInfo());

  useIsomorphicLayoutEffect(() => {
    const handleResize = () => {
      setScrollInfo(getScrollInfo());
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleResize);
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleResize);
      }
    };
  }, []);

  return scrollInfo;
}
